import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import LegalModal from "../components/LegalModal";
import { 
  Zap, 
  Target, 
  Globe, 
  MessageSquare, 
  Rocket, 
  Shield,
  CheckCircle,
  ArrowRight,
  Phone,
  Mail,
  Instagram,
  MessageCircle,
  Clock,
  RefreshCw,
  AlertCircle,
  AlertTriangle
} from 'lucide-react';
import { mockServices, mockProblems, mockSolutions, mockWhyPoints } from '../data/mockData';
import '../styles/landing.css';

const API = "https://anti9five.onrender.com/api";


const LandingPage = () => {
 const [formData, setFormData] = useState({
  name: '',
  phone: '',
  email: '',
  business_type: '',
  message: '',
});
  const [legalOpen, setLegalOpen] = useState(false);
const [legalType, setLegalType] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await axios.post(
      `${API}/contact`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data?.success) {
      setSubmitSuccess(true);

      setFormData({
        name: '',
        phone: '',
        email: '',
        business_type: '',
        message: ''
      });

      setTimeout(() => setSubmitSuccess(false), 5000);
    } else {
      alert("Something went wrong. Please try again.");
    }
  } catch (error) {
    console.error("Form submission failed:", error);
    alert("Server error. Please try again or WhatsApp us.");
  } finally {
    setIsSubmitting(false);
  }
};

  const openWhatsApp = () => {
     // ✅ GA4 tracking FIRST
  if (window.gtag) {
    window.gtag('event', 'whatsapp_click', {
      event_category: 'engagement',
      event_label: 'landing_page_whatsapp',
    });
  }
    const phoneNumber = '918925535344';
    const message = 'I am Interested in your Service';
    const encodedMessage = encodeURIComponent(message);
    
    // Check if mobile device
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // On mobile, use whatsapp:// protocol for direct app opening
      window.location.href = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;
    } else {
      // On desktop, use web.whatsapp.com
      window.open(`https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');
    }
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('.contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const problemIcons = {
    'Clock': Clock,
    'RefreshCw': RefreshCw,
    'AlertCircle': AlertCircle,
  
  };

  const serviceIcons = {
    'Website Development': Globe,
    'Landing Pages': Target,
    'Lead Systems': Zap,
    'WhatsApp Automation': MessageSquare,
    'Digital Setup': Rocket
  };

  useEffect(() => {
    // Fade-in animation on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.fade-in-scroll').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

useEffect(() => {
  let lastScrollY = window.scrollY;
  const navbar = document.querySelector(".navbar");

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // background blur after scroll
    if (currentScrollY > 10) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }

    // scroll down → hide
    if (currentScrollY > lastScrollY && currentScrollY > 80) {
      navbar.classList.add("hide");
    }
    // scroll up → show
    else {
      navbar.classList.remove("hide");
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, []);

useEffect(() => {
  if (legalOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [legalOpen]);

  useEffect(() => {
    if (submitSuccess) {
      const timer = setTimeout(() => {
        setSubmitSuccess(false);
        setFormData({
          name: "",
          phone: "",
          email: "",
          businessType: "",
          message: "",
        });
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [submitSuccess]);


  return (
    <div className="landing-page">
      {/* Header/Navbar */}
      <header className="navbar">
        <div className="container navbar-content">
          <div className="navbar-logo">
            <img src="/anti9five-logo.png" alt="ANTI9FIVE" className="logo-image" />
          </div>
          <nav className="navbar-links">
            
            <a href="#services" className="nav-link">Services</a>
            <a href="#pricing" className="nav-link">Pricing</a>
            <a href="#why" className="nav-link">Why Us</a>
            <a href="#contact" className="nav-link">Contact</a>
            <Button className="btn-secondary nav-cta" size="sm" onClick={openWhatsApp}>
              <MessageCircle size={18} />
            </Button>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-glow"></div>
        <div className="container hero-content">
          <h1 className="hero-headline fade-in-scroll">
            Break the 9–5 mindset<br />
            Build systems<br />
            Gain freedom
          </h1>
          <p className="hero-subtitle fade-in-scroll">
            <span className="tamil-text">You’re not tired of working</span><br />
            <span className="tamil-text">You’re tired of working without systems!</span>
          </p>
          <p className="hero-description fade-in-scroll">
            We help businesses grow using websites, automation, and lead systems <br />
            — without burnout.
          </p>

          <div className="hero-cta-group fade-in-scroll">
            <Button className="btn-primary" size="lg" onClick={scrollToContact}>
              Get Started <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button className="btn-secondary" size="lg" onClick={openWhatsApp}>
              <MessageCircle className="mr-2" size={20} />
              Chat on WhatsApp
            </Button>
          </div>
          {/* 👇 Founder line – FINAL */}
<p className="founder-text fade-in-scroll">
  Founded by <strong>Sam</strong>
</p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="problem-section">
        <div className="container">
          <h2 className="section-title fade-in-scroll">The Real Problem</h2>
          <p className="problem-intro">
  These are not skill problems. They are system problems.
</p>

          <div className="problem-grid">
            {mockProblems.map((problem, index) => {
  const IconComponent = problemIcons[problem.icon] || AlertCircle;

  return (
    <div
      key={index}
      className={`problem-card fade-in-scroll ${
        index === 1 ? 'problem-focus' : ''
      }`}
    >
      <div className="problem-icon">
        <IconComponent size={48} strokeWidth={1.5} />
      </div>
      <p className="problem-text">{problem.text}</p>
    </div>
  );
})}

          </div>
        </div>
      </section>
      


      {/* Solution Section */}
      <section className="solution-section">
        <div className="container">
          <h2 className="section-title fade-in-scroll">How ANTI9FIVE Helps</h2>
          <p className="section-subtitle fade-in-scroll">
            We build digital systems that work for you — so your business doesn't depend fully on you.
          </p>
          <div className="solution-grid">
            {mockSolutions.map((solution, index) => (
              <div key={index} className="solution-card fade-in-scroll">
                <CheckCircle className="solution-icon" size={24} />
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="container">
          <h2 className="section-title fade-in-scroll">Our Services</h2>
          <div className="services-grid">
            {mockServices.map((service, index) => {
              const IconComponent = serviceIcons[service.name] || Rocket;
              return (
                <Card key={index} className="service-card fade-in-scroll">
                  <div className="service-icon-wrapper">
                    <IconComponent className="service-icon" size={32} />
                  </div>
                  <h3 className="service-name">{service.name}</h3>
                  <p className="service-benefit">{service.benefit}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
<section id="pricing" className="pricing-section">

  <div className="container">
    <h2 className="section-title fade-in-scroll">Automation Packages</h2>
    <p className="section-subtitle fade-in-scroll">
      Simple pricing. Scalable systems. No unnecessary tools.
    </p>

    <div className="pricing-grid">
      
      {/* Basic */}
      <div className="pricing-card fade-in-scroll">
        <h3 className="pricing-title">Basic Automation</h3>
        <p className="pricing-price">Starting at ₹5,999</p>

        <ul className="pricing-features">
          <li><CheckCircle size={18} /> 1-page landing website</li>
          <li><CheckCircle size={18} /> Lead form setup</li>
          <li><CheckCircle size={18} /> Google Sheet auto save</li>
          <li><CheckCircle size={18} /> Email notification</li>
          <li><CheckCircle size={18} /> WhatsApp click CTA</li>
        </ul>

        <Button className="btn-secondary pricing-btn" onClick={scrollToContact}>
          Get Started <ArrowRight size={18} />
        </Button>
      </div>

      {/* Standard */}
      <div className="pricing-card pricing-highlight fade-in-scroll">
        <span className="pricing-badge">Most Popular</span>
        <h3 className="pricing-title">CRM + Follow-up Automation</h3>
        <p className="pricing-price">Starting at ₹12,999</p>

        <ul className="pricing-features">
          <li><CheckCircle size={18} /> Conversion-focused landing website</li>
          <li><CheckCircle size={18} /> Google Sheet CRM</li>
          <li><CheckCircle size={18} /> Lead status tracking</li>
          <li><CheckCircle size={18} /> Auto follow-up logic</li>
          <li><CheckCircle size={18} /> Notes & call summary</li>
          <li><CheckCircle size={18} /> Lead priority tagging</li>
        </ul>

        <Button className="btn-primary pricing-btn" onClick={scrollToContact}>
          Build My System <ArrowRight size={18} />
        </Button>
      </div>

      {/* Advanced */}
      <div className="pricing-card fade-in-scroll">
        <h3 className="pricing-title">Advanced Automation System</h3>
        <p className="pricing-price">Starting at ₹28,888</p>

        <ul className="pricing-features">
          <li><CheckCircle size={18} /> Custom website / system pages</li>
          <li><CheckCircle size={18} /> Advanced CRM setup</li>
          <li><CheckCircle size={18} /> Payment tracking</li>
          <li><CheckCircle size={18} /> Follow-up reminders</li>
          <li><CheckCircle size={18} /> Business dashboard</li>
          <li><CheckCircle size={18} /> Setup & training</li>
        </ul>

        <Button className="btn-secondary pricing-btn" onClick={scrollToContact}>
          Get Custom Quote <ArrowRight size={18} />
        </Button>
      </div>

    </div>

    <p className="pricing-note fade-in-scroll">
       Website is built as part of the system — not as a standalone design.
      "Final pricing depends on lead volume & system complexity"
      
    </p>
  </div>
</section>


      {/* Why ANTI9FIVE Section */}
      <section id="why" className="why-section">
        <div className="container">
          <h2 className="section-title fade-in-scroll">Why ANTI9FIVE</h2>
          <div className="why-grid">
            {mockWhyPoints.map((point, index) => (
              <div key={index} className="why-card fade-in-scroll">
                <Shield className="why-icon" size={28} />
                <h3 className="why-title">{point.title}</h3>
                <p className="why-description">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info fade-in-scroll">
  <h2 className="section-title">Ready to Build Your System?</h2>
  <p className="contact-description">
    Let's discuss how we can help your business grow without burnout.
  </p>

  <div className="contact-details">
    <div className="contact-item">
      <Phone size={20} />
      <span>+91 8925535344</span>
    </div>

    <div className="contact-item">
      <Mail size={20} />
      <span>connectwithanti9five@gmail.com</span>
    </div>

    <div className="contact-item">
      <Instagram size={20} />
      <span>@anti9five</span>
    </div>
  </div>

  {/* 🔽 ADD HERE */}
  <div className="contact-legal-actions">
   <button
  className="legal-btn"
  onClick={() => {
    setLegalType("terms");
    setLegalOpen(true);
  }}
>
  Terms & Conditions
</button>

   <button
  className="legal-btn"
  onClick={() => {
    setLegalType("privacy");
    setLegalOpen(true);
  }}
>
  Privacy Policy
</button>
<LegalModal
  open={legalOpen}
  type={legalType}
  onClose={() => setLegalOpen(false)}
/>

  </div>
</div>

            <form onSubmit={handleSubmit} className="contact-form fade-in-scroll">
              <div className="form-group">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
               <label htmlFor="business_type">Business Type</label>
                <Input
                  id="business_type"
                  name="business_type"
                  value={formData.business_type}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                  />
              </div>
              <div className="form-group">
                <Label htmlFor="message">Message</Label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  required
                  className="form-input"
                />
              </div>
            {submitSuccess && (
  <div className="success-message">
    <CheckCircle size={20} />
    <span>✅ Message sent. We’ll contact you shortly.</span>
  </div>
)}
              <Button type="submit" className="btn-primary submit-btn" disabled={isSubmitting}>
                {isSubmitting
    ? "Processing securely..."
    : submitSuccess
    ? "Sent ✓"
    : "Send Message"}
</Button>
              <p class="form-note">
  No spam. No pressure. Just clarity.
</p>

            </form>
          </div>
        </div>
      </section>
<hr />
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3 className="footer-logo">ANTI9FIVE</h3>
              <p className="footer-tagline">Build systems. Not stress.</p>
              <p class="footer-about">
We help founders and small businesses replace manual work with
simple, scalable digital systems — so growth doesn’t mean burnout.
</p>

            </div>
            <div className="footer-links">
              <div className="footer-column"> 
                <h4>Explore</h4>
                 <a href="#services">Services</a>
                 <a href="#why">Why Anti9five</a>
                 <a href="#pricing">Pricing</a>
                 <a href="#contact">Contact</a>
                 </div>
              <div className="footer-column">
                <h4>Contact</h4>
                <a href="tel:+918925535344">+91 8925535344</a>
                <a href="mailto:connectwithanti9five@gmail.com">connectwithanti9five@gmail.com</a>
              </div>
               
              <div className="footer-column">
                <h4>Social</h4>
                <a href="https://instagram.com/anti9five" target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
                <a href="https://wa.me/918925535344" target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Anti9five. Built & managed by Sam. </p>
          </div>
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <button className="whatsapp-float" onClick={openWhatsApp} aria-label="Chat on WhatsApp">
        <MessageCircle size={28} />
      </button>
    </div>
  );
};

export default LandingPage;
